import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export type InfoRowProps = {
    label: React.ReactNode;
    value: React.ReactNode;
    sx?: SxProps<Theme>;
};

const InfoRow: React.FC<InfoRowProps> = ({ label, value, sx }) => (
    <Box
        sx={[
            {
                display: 'flex',
                flexDirection: 'column',
                py: 0.5,
                borderBottom: '1px solid',
                borderColor: 'grey.100',
                '&:last-child': {
                    borderBottom: 0,
                },
            },
            // `sx` は配列で渡すと左から順にマージされ、後ろの指定が優先されます。
            // 呼び出し側の `sx`（object/array 両対応）を末尾に連結して、ベーススタイルを必要に応じて上書きできるようにしています。
            ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
    >
        <Typography
            variant="caption"
            sx={{
                color: 'grey.400',
                fontWeight: 500,
                mb: 0.5,
            }}
        >
            {label}
        </Typography>
        <Typography
            sx={{
                color: 'grey.800',
                wordBreak: 'break-word',
                lineHeight: 1.6,
            }}
        >
            {value}
        </Typography>
    </Box>
);

export default InfoRow;
